
export const selectionSiteMutations = {
    SET_SELECTED_SITES_FLEET: (state, payload) => {
        state.selectedSitesFleet = payload;
    }
};
